import { SubItemFormFilling } from '../../../Filling/Types';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { Radio, RadioGroup, Stack, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { useContext, useEffect } from 'react';
import CheckIcon from '../../CheckIcon';
import AdditionalInfo from '../../Structure/AdditionalInfo';
import { NewWebFormContext } from '../../../../context/NewWebFormContext';

type props = {
  avaliacao: number | null,
  setAvaliacao: Function,
  subitem: SubItemFormFilling,
};

export default function Avaliacao({
  avaliacao,
  setAvaliacao,
  subitem }: props) {
  const { ForceUpdate } = useContext(NewWebFormContext);

  const textFieldTitle: string = (() => {
    let title = '';
    if (CheckIcon(subitem, avaliacao) === 'naoOk') {
      title += '* ';
    }
    title += `${subitem.id + 1} - ${subitem.nome}`;
    return title;
  })();

  useEffect(() => {
    if (subitem.nota || typeof subitem.nota === 'number') {
      setAvaliacao(subitem.nota);
    }
  }, []);

  useEffect(() => {
    if (subitem.padrao) {
      setAvaliacao(parseInt(subitem.padrao));
      subitem.nota = parseInt(subitem.padrao);
    }
    if (CheckIcon(subitem, avaliacao) === 'ok') {
      subitem.checked = true;
    }
  }, []);

  useEffect(() => {
    if (avaliacao || typeof avaliacao === 'number') {
      subitem.nota = avaliacao;
    }
    if (CheckIcon(subitem, avaliacao) === 'ok') {
      subitem.checked = true;
    } else {
      delete subitem.checked;
    }
    ForceUpdate();
  }, [avaliacao]);

  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {textFieldTitle}
      </Typography>
      <Stack
        justifyContent="space-between"
        direction="row"
        sx={{
          minWidth: '100%',
          height: '100%',
        }}>
        <FormControl>
          <FormLabel
            sx={{
              '&$focused': {
                color: '#643E91',
              },
            }}
          >
          </FormLabel>
          <RadioGroup
            className={`${subitem.itemid}|${subitem.id}`}
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue={avaliacao as number}
            name="radio-buttons-group"
          >
            {subitem?.avaliacao?.map((e, i) => (
              <FormControlLabel
                key={i}
                value={i}
                control={
                  <Radio
                    checked={avaliacao === i}
                    onChange={(e) => setAvaliacao(Number(e.target.value))}
                    sx={{
                      color: '#643EFF',
                      '&.Mui-checked': {
                        color: '#643E91',
                      },
                    }}
                  />
                }
                label={e.nome}
              />
            ))}
          </RadioGroup>
        </FormControl>
        <Stack>
          <Button
            variant="outlined"
            size={"small"}
            onClick={() => {
              setAvaliacao(null);
              delete subitem.nota;
            }}
            disabled={avaliacao === null}
            sx={{
              color: '#ffffff',
              borderColor: '#643E91',
              backgroundColor: '#643E91',
              '&:disabled': {
                borderColor: '#643E91',
                backgroundColor: '#aa86d6',
                color: 'white'
              },
              '&:hover': {
                borderColor: '#643E91',
                backgroundColor: '#aa86d6',
                color: 'white'
              }
            }}
          >
            Desmarcar
          </Button>
        </Stack>
      </Stack >
      {typeof avaliacao === 'number'
        && (!subitem.hideImg || !subitem.hideComent)
        && <AdditionalInfo subItem={subitem} />}
    </>
  );
}
